export function request(body) {
    return {
        type: 'UPLOAD_BANNER_IMAGE_REQUEST',
        body
    };
}

export function error(errors) {
    return {
        type: 'UPLOAD_BANNER_IMAGE_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'UPLOAD_BANNER_IMAGE_FINISH',
        data
    };
}
